/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Cohort } from './cohort';

export type CourseStudentCohort = Cohort | null;
